// Copyright 2016 Sorama B.V.

import { MeasurementDevice } from "services/Hardware/Datatypes/MeasurementDevice";
import { RegistrableMeasurementDevice } from "services/Hardware/Datatypes/RegistrableMeasurementDevice";

export abstract class IMeasurementDeviceManagement {
    /**
     * Returns the measurementDevice from the storage used by the implementing service, if the user has permission to use the measurementDevice.
     * Returns a new MeasurementDevice, containing all the properties of the input MeasurementDevice and all valid CaptureDevices.
     * @param measurementDevices Array with MeasurementDevices to check.
     **/
    abstract getRegisteredMeasurementDevices(measurementDevices: MeasurementDevice[]): Promise<MeasurementDevice[]>;

    /**
     * Register a measurement device to the storage used by the implementing service.
     * @param registrableMeasurementDevice The RegistrableMeasurementDevice to register
     */
    abstract registerMeasurementDevice(
        registrableMeasurementDevice: RegistrableMeasurementDevice
    ): Promise<MeasurementDevice>;
}
